module.exports = __webpack_public_path__ + "img/skin_2.c588d919.png";